import {
    getSelectedYearMonths,
    monthsIndexes
} from '../../../../Common/Util/getMonthsByYear';
import { useServicesChartsDataContext } from './useServicesChartsDataContext';

export const useSimpleChart = () => {
    const { chartData, filters } = useServicesChartsDataContext();

    const months = getSelectedYearMonths(filters);

    const series = months.map((month) => {
        const found = chartData.increments.find(
            (counter) =>
                parseInt(counter.mes_competencia, 10) === monthsIndexes[month]
        );

        return found ? Number(found.valor_incremento) : 0;
    });

    return {
        values: series,
        subtitles: months
    };
};
